import request from "@/utils/request";

// 列表(主数据列表)
export function loadExpenseFlowDynamicTemplateListDataApi(data) {
  return request({
    url: "web/expenseFlowDynamicTemplate/listData",
    method: "post",
    data
  });
}
// 导出
export function loadExpenseFlowDynamicTemplateExportDataApi(data) {
  return request({
    url: "web/expenseFlowDynamicTemplate/exportData",
    method: "post",
    data
  });
}

// 操作
export function saveOrUpdateExpenseFlowDynamicTemplateApi(data) {
  return request({
    url: "web/expenseFlowDynamicTemplate/saveOrUpdate",
    method: "post",
    data
  });
}

// 查看
export function initExpenseFlowDynamicTemplateApi(data) {
  return request({
    url: "web/expenseFlowDynamicTemplate/init",
    method: "post",
    data
  });
}

// 获取下拉列表
export function getExpenseFlowDynamicTemplateListApi(data) {
  return request({
      url: "web/expenseFlowDynamicTemplate/listSelectData",
      method: "post",
      data
  });
}